export default {
    getIsNavOpen: (state) => state.isNavOpen,
    getIsMobileDensity: (state) => state.isMobileDensity,
  }
  